module.exports = __webpack_public_path__ + "static/media/cp42.532ecf19.png";